import { render, staticRenderFns } from "./ServiceDetailsModal.vue?vue&type=template&id=6a5fa385&scoped=true&"
import script from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailsModal.vue?vue&type=style&index=0&id=6a5fa385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5fa385",
  null
  
)

export default component.exports